import dayjs from 'dayjs'

/**
 * Default trial duration in days. Used for both initial invitations and
 * extensions until the SME-editable input lands in v2.
 */
export const TRIAL_DAYS = 28

/**
 * Human-readable label for the trial duration. Decoupled from TRIAL_DAYS so
 * we can market a "one month" trial even though the backend uses 28 days.
 */
export const TRIAL_DURATION_LABEL = 'one month'

/**
 * Bounds for the SWI-Admin-only "Trial duration (days)" override on the
 * Add User modal. Kept here so any future caller (e.g. extend flows) can
 * share the same min/max.
 */
export const MIN_TRIAL_DAYS = 1
export const MAX_TRIAL_DAYS = 365

export type TrialState =
  | { kind: 'none' }
  | { kind: 'pending' }
  | { kind: 'active'; endsAt: Date; daysRemaining: number }
  | { kind: 'expired'; endedAt: Date }

export function getTrialState(user: { isTrial: boolean; trialEnd: string | null }): TrialState {
  if (!user.isTrial) return { kind: 'none' }
  if (!user.trialEnd) return { kind: 'pending' }

  const end = dayjs(user.trialEnd)
  if (!end.isValid()) return { kind: 'pending' }

  const now = dayjs()
  if (end.isBefore(now)) {
    return { kind: 'expired', endedAt: end.toDate() }
  }

  // Round up so a partial day still counts as 1 day remaining.
  const daysRemaining = Math.max(1, Math.ceil(end.diff(now, 'day', true)))
  return { kind: 'active', endsAt: end.toDate(), daysRemaining }
}
